module.exports = __webpack_public_path__ + "static/media/rainy-4.c8cdb216.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/rainy-4.svg
// module id = 522
// module chunks = 0